import React from 'react';
import { Component } from "react";
import { Link } from "react-router-dom";
import site from "../../../../constants/site";
import Navigate from "../../../../util/Navigate";
import Glitch from 'glitch-javascript-sdk';

// Pull community data if it exists
let community = Glitch.util.Storage.get('community');

// Prepare banner data
let BannerListContent = [
    {
        bgImgUrl: (community?.banner_image) ? community.banner_image : '/assets/images/banner/home-2/bg-2.jpg',
        title: site.name,
        subtitle: site.tagline,
        desc: site.description,
        btnText: 'join us today',
    },
];

class BannerTwo extends Component {

    render() {
        return (
            <div className="banner__slider overflow-hidden">
                {BannerListContent.map((val, i) => (
                    <div
                        className="banner1"
                        key={i}
                        style={{
                            position: 'relative', // so we can position the overlay
                            backgroundImage: `url(${val.bgImgUrl})`,
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                        }}
                    >
                        {/* Dark Overlay */}
                        <div
                            style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                backgroundColor: 'rgba(0,0,0,0.6)',  // adjust opacity as needed
                                zIndex: 1,
                            }}
                        ></div>

                        {/* Actual banner content is placed above the overlay */}
                        <div className="container" style={{ position: 'relative', zIndex: 2 }}>
                            <div className="row g-0">
                                <div className="col-lg-6 col-12">
                                    <div className="banner__content1-1" style={{ paddingTop: '150px', paddingBottom: '100px' }}>
                                        <h1>{community?.name}</h1>
                                        <p className="lead">{community?.tagline}</p>

                                        {Glitch.util.Session.hasJoinedCommunity() ? (
                                            <div className="mt-5 mb-5"></div>
                                        ) : (
                                            <>
                                                {Glitch.util.Session.isLoggedIn() ? (
                                                    <Link to={Navigate.joinPage()} className="default-button">
                                                        <span>{val?.btnText} <i className="icofont-play-alt-1"></i></span>
                                                    </Link>
                                                ) : (
                                                    <Link to={Navigate.authLogin()} className="default-button">
                                                        <span>{val?.btnText} <i className="icofont-play-alt-1"></i></span>
                                                    </Link>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        );
    }
}

export default BannerTwo;
